import { jsxs as y, jsx as r } from "react/jsx-runtime";
import { ThemeProvider as h } from "@ucl/shared-component-foundations/themeProvider";
import { useState as g, useRef as b, useEffect as M, useMemo as u } from "react";
import { createGlobalStyle as E } from "styled-components";
import { C as N } from "./ComponentContext-3bb2d205.js";
import { P as s } from "./PageContext-57b2437f.js";
import "@ucl/react-library/useIsMounted";
import { ModelManager as w } from "@adobe/aem-spa-page-model-manager";
import "html-react-parser";
import "sanitize-html";
import "@adobe/aem-react-editable-components";
import { withErrorBoundary as C } from "./withErrorBoundary.js";
import "./index-0371017d.js";
import "./withAuthorView-7410599f.js";
import { A } from "./AEMModelClient-a9944944.js";
import "@ucl/shared-component-foundations/foundations";
import "./component-a7888ba1.js";
import "@ucl/shared-component-foundations";
const S = (e) => e && Object.keys(e).length > 0, v = (e, n) => typeof window < "u" && !!(e != null && e.trim()) && !!(n != null && n.trim()), f = (e, n, m, t) => e ?? (n ? new A(n, m, t) : void 0);
function k(e) {
  const [n, m] = g(e.model || {}), t = b(e);
  M(() => {
    t.current = e;
  }, [
    e
  ]);
  const o = b(f(e.customModelClient, e.aemHost, e.aemUser, e.aemPassword));
  return M(() => {
    o.current = f(e.customModelClient, e.aemHost, e.aemUser, e.aemPassword);
  }, [
    e.aemHost,
    e.aemPassword,
    e.aemUser,
    e.customModelClient
  ]), u(() => {
    var a, c;
    if (v(t.current.aemHost, t.current.pagePath)) {
      if (S(t.current.model))
        return (c = (a = t.current) == null ? void 0 : a.onPageModelLoad) == null ? void 0 : c.call(a, t.current.model || {});
      w.initialize({
        path: t.current.pagePath,
        model: t.current.model,
        modelClient: o.current
      }).then((i) => {
        var l, d;
        m(i), (d = (l = t.current) == null ? void 0 : l.onPageModelLoad) == null || d.call(l, i || {});
      }).catch((i) => {
        var l, d;
        console.error(i), m({}), (d = (l = t.current) == null ? void 0 : l.onPageModelError) == null || d.call(l, i);
      });
    }
  }, []), {
    pageModel: n,
    customModelClient: o.current
  };
}
const F = /* @__PURE__ */ E([
  ".cq-placeholder,.new{display:flex;flex:1;width:100%;min-width:200px;box-sizing:border-box;}"
]);
function P(e) {
  const { pageModel: n, customModelClient: m } = k(e), t = u(() => ({
    pagePath: e.pagePath,
    pageModel: n,
    themeName: n == null ? void 0 : n.themeName,
    mode: n == null ? void 0 : n.mode,
    editableFallback: e.editableFallback,
    noEditableFallback: e.noEditableFallback,
    componentManager: e.componentManager,
    customModelClient: m
  }), [
    m,
    n,
    e.componentManager,
    e.editableFallback,
    e.noEditableFallback,
    e.pagePath
  ]), o = u(() => ({
    globalStyles: e.globalStyles,
    disableGlobalStyles: e.disableGlobalStyles,
    theme: e.theme,
    themes: e.themes,
    themeName: e.themeName || (t == null ? void 0 : t.themeName),
    mode: e.mode || (t == null ? void 0 : t.mode),
    productTeamName: e.productTeamName || "AEM Provider",
    disableAnalytics: (e == null ? void 0 : e.disableAnalytics) ?? !0
  }), [
    t == null ? void 0 : t.mode,
    t == null ? void 0 : t.themeName,
    e.disableGlobalStyles,
    e.globalStyles,
    e.mode,
    e.productTeamName,
    e.theme,
    e.themeName,
    e.themes,
    e.disableAnalytics
  ]), a = (c) => typeof e.children == "function" ? e.children({
    ...e,
    ...t,
    ...c
  }) : e.children;
  return /* @__PURE__ */ y(s.Provider, {
    value: t,
    children: [
      /* @__PURE__ */ r(F, {}),
      e.componentManager && /* @__PURE__ */ r(N.Provider, {
        value: e.componentManager,
        children: /* @__PURE__ */ r(h, {
          ...o,
          children: a
        })
      }),
      !e.componentManager && /* @__PURE__ */ r(h, {
        ...o,
        children: a
      })
    ]
  });
}
P.displayName = "AEMPage";
const X = C(P);
export {
  X as AEMPage
};
